import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DataService } from '../../providers/data.service';
import { AuthService } from '../../providers/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertService } from '../../providers/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-refer-friend',
  templateUrl: './interests.component.html',
  styleUrls: ['./interests.component.scss'],
})
export class InterestsComponent implements OnInit {
  categories$: Observable<any[]>;
  @Input() interests: any;
  interestsArray: any = [];


  constructor(
    public modalController: ModalController,
    private dataSvc: DataService,
    private authSvc: AuthService,
    private alertSvc: AlertService) { }

  ngOnInit() {
    this.categories$ = this.dataSvc.getJsonData('categoriesAll').pipe(
      map((data: any) => data.categories)
    );
    this.interestsArray = this.interests;
  }

  highlightInterest(name: string) {
    if (this.interestsArray.indexOf(name) > -1) {
      return true;
    } else {
      return false;
    }
  }

  createInterests(name: string) {
    if (this.interestsArray.indexOf(name) > -1) {
      this.interestsArray = this.interestsArray.filter(e => e !== name);
    } else {
      this.interestsArray.push(name);
    }
    this.interestsArray.sort();
  }

  sendInterests() {
    if (this.interestsArray.length >= 3) {
      this.interests = this.interestsArray;
      this.authSvc.setInterests(this.interests);
      this.dismissModal();
    } else {
      this.alertSvc.showError('Must choose at least 3 categories');
    }
  }

  dismissModal() {
    this.modalController.dismiss('data');
  }
}
